
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/[course]/[lessons]",
      function () {
        return require("private-next-pages/courses/[course]/[lessons]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/courses/[course]/[lessons]"])
      });
    }
  